<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('editPoi') }}</h2>
    <FormPointOfInterest :basePoi="poi" @submit-requested="submitRequested"></FormPointOfInterest>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormPointOfInterest from '../forms/FormPointOfInterest.vue'
import router from '@/router';

  export default {  data () {
    return {
      poi: null
    }
    
  },
  components: { FormPointOfInterest },
    computed:{
      ...mapState('pois', ['listOutput']),
    },
    methods: {
      ...mapActions('pois', ['editPoi']),
      ...mapActions('pois', ['getList']),
      submitRequested (poi) {
        this.editPoi(poi);
      },
    },
    mounted: function()
    {
      if(!this.$route.params.poi)
      {
        router.push({ path: '/pois/list' });
      }
      else
      {
        this.poi = this.$route.params.poi;
      }
    }
  }
</script> 
 
<style scoped>
</style> 